import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import AuthContext from '../../auth/authContext';
import EmailService from "../../HttpService/EmailService";
import UserService from '../../HttpService/UsersService';
import Swal from 'sweetalert2';
import { useNavigate, useLocation } from "react-router-dom";
import { AuxiliaryService } from "../../HttpService/AuxiliaryService";
import introductionImage from '../../assets/images/UserManual/mainscreen.png';
import forgotpassword from '../../assets/images/UserManual/forgotpassword.png';
import inicioadmin from '../../assets/images/UserManual/logging.png';
import userProfile from '../../assets/images/UserManual/userProfile.png';
import changePassword from '../../assets/images/UserManual/changePassword.png';
import loggedTCP from '../../assets/images/UserManual/logedTCPS.png';
import requestTCP from '../../assets/images/UserManual/requestTCP.png';
import details from '../../assets/images/UserManual/details.png';
import createRequestPopupImage from '../../assets/images/UserManual/createNewUpdate.png';
import newItemPopupImage from '../../assets/images/UserManual/new_item_popup.png';
import newEUAcquisPopupImage from '../../assets/images/UserManual/new_eu_acquis_popup.png';
import notificationsTabImage from '../../assets/images/UserManual/notifications_tab.png';
import tasksWindowImage from '../../assets/images/UserManual/tasks_window.png';
import validateDataCollectionImage from '../../assets/images/UserManual/validate_data_collection.png';
import changesRequest from '../../assets/images/UserManual/changes_request.png';
import saveChangesPopupImage from '../../assets/images/UserManual/save_changes_popup.png';
import rejectRequestPopupImage from '../../assets/images/UserManual/reject_request_popup.png';
import importData from '../../assets/images/UserManual/import_data_tcps.png'

import tasksWindowImageReg from '../../assets/images/UserManual/tasks_windowReg.png';
import itemToMonitorFormImageReg from '../../assets/images/UserManual/item_to_monitor_formReg.png';
import euAcquisFormImageReg from '../../assets/images/UserManual/eu_acquis_formReg.png';
import rejectRequestPopupImageReg from '../../assets/images/UserManual/reject_request_popupReg.png';

import regionalCoordinatorTasksImage from '../../assets/images/UserManual/regional_coordinator_tasks.png';
import regionalCoordinatorValidateDataCollectionImage from '../../assets/images/UserManual/regional_coordinator_validate_data_collection.png';
import regionalUserItemToMonitorFormImage from '../../assets/images/UserManual/regional_user_item_to_monitor_form.png';
import regionalUserEUAcquisFormImage from '../../assets/images/UserManual/regional_user_eu_acquis_form.png';
import regionalUserUpdatedRequestFormImage from '../../assets/images/UserManual/regional_user_updated_request_form.png';
import regionalUserUpadated2RequestFromImage from '../../assets/images/UserManual/regional_user_updated_request_form2.png';
import regionalUserInfra from '../../assets/images/UserManual/regionalUserInfra.png';
import regUserImport from '../../assets/images/UserManual/regUserImport.png';
import regUserValidate from '../../assets/images/UserManual/regUserValidate.png'
import allowNoti from '../../assets/images/UserManual/AllowNotification.png'
import style from "./form.module.scss";

import dataSharing1 from '../../assets/images/UserManual/dataSharing1.png'
import dataSharing2 from '../../assets/images/UserManual/dataSharing2.png'
import dataSharing3 from '../../assets/images/UserManual/dataSharing3.png'
import dataSharing4 from '../../assets/images/UserManual/dataSharing4.png'
import dataSharing5 from '../../assets/images/UserManual/dataSharing5.png'
import dataSharing6 from '../../assets/images/UserManual/dataSharing6.png'
import dataSharing7 from '../../assets/images/UserManual/dataSharing7.png'
import dataSharing8 from '../../assets/images/UserManual/dataSharing8.png'
import dataSharing9 from '../../assets/images/UserManual/dataSharing9.png'
import dataSharing10 from '../../assets/images/UserManual/dataSharing10.png'
import dataSharing11 from '../../assets/images/UserManual/dataSharing11.png'
import dataSharing12 from '../../assets/images/UserManual/dataSharing12.png'
import dataSharing13 from '../../assets/images/UserManual/dataSharing13.png'
import dataSharing14 from '../../assets/images/UserManual/dataSharing14.png'
import dataSharing15 from '../../assets/images/UserManual/dataSharing15.png'
import dataSharing16 from '../../assets/images/UserManual/dataSharing16.png'
import dataSharing17 from '../../assets/images/UserManual/dataSharing17.png'
import dataSharing18 from '../../assets/images/UserManual/dataSharing18.png'
import dataSharing19 from '../../assets/images/UserManual/dataSharing19.png'
import dataSharing20 from '../../assets/images/UserManual/dataSharing20.png'
import dataSharing21 from '../../assets/images/UserManual/dataSharing21.png'
import dataSharing22 from '../../assets/images/UserManual/dataSharing22.png'
import dataSharing23 from '../../assets/images/UserManual/dataSharing23.png'
import dataSharing24 from '../../assets/images/UserManual/dataSharing24.png'
import dataSharing25 from '../../assets/images/UserManual/dataSharing25.png'
import dataSharing26 from '../../assets/images/UserManual/dataSharing26.png'
import dataSharing27 from '../../assets/images/UserManual/dataSharing27.png'
import dataSharing28 from '../../assets/images/UserManual/dataSharing28.png'
import dataSharing29 from '../../assets/images/UserManual/dataSharing29.png'
import dataSharing30 from '../../assets/images/UserManual/dataSharing30.png'
import dataSharing31 from '../../assets/images/UserManual/dataSharing31.png'
import dataSharing32 from '../../assets/images/UserManual/dataSharing32.png'
import dataSharing33 from '../../assets/images/UserManual/dataSharing33.png'
import dataSharing34 from '../../assets/images/UserManual/dataSharing34.png'
import dataSharing35 from '../../assets/images/UserManual/dataSharing35.png'
import dataSharing36 from '../../assets/images/UserManual/dataSharing36.png'
import dataSharing37 from '../../assets/images/UserManual/dataSharing37.png'
import dataSharing38 from '../../assets/images/UserManual/dataSharing38.png'
import dataSharing39 from '../../assets/images/UserManual/dataSharing39.png'
import dataSharing40 from '../../assets/images/UserManual/dataSharing40.png'
import dataSharing41 from '../../assets/images/UserManual/dataSharing41.png'
import dataSharing42 from '../../assets/images/UserManual/dataSharing42.png'
import dataSharing43 from '../../assets/images/UserManual/dataSharing43.png'
import dataSharing44 from '../../assets/images/UserManual/dataSharing44.png'
import dataSharing45 from '../../assets/images/UserManual/dataSharing45.png'
import dataSharing46 from '../../assets/images/UserManual/dataSharing46.png'
import dataSharing47 from '../../assets/images/UserManual/dataSharing47.png'
import dataSharing48 from '../../assets/images/UserManual/dataSharing48.png'
import dataSharing49 from '../../assets/images/UserManual/dataSharing49.png'
import dataSharing50 from '../../assets/images/UserManual/dataSharing50.png'
import dataSharing51 from '../../assets/images/UserManual/dataSharing51.png'
import dataSharing52 from '../../assets/images/UserManual/dataSharing52.png'
import dataSharing53 from '../../assets/images/UserManual/dataSharing53.png'
import dataSharing54 from '../../assets/images/UserManual/dataSharing54.png'
import dataSharing55 from '../../assets/images/UserManual/dataSharing55.png'
import dataSharing56 from '../../assets/images/UserManual/dataSharing56.png'
import dataSharing57 from '../../assets/images/UserManual/dataSharing57.png'
import dataSharing58 from '../../assets/images/UserManual/dataSharing58.png'
import dataSharing59 from '../../assets/images/UserManual/dataSharing59.png'
import dataSharing60 from '../../assets/images/UserManual/dataSharing60.png'
import dataSharing61 from '../../assets/images/UserManual/dataSharing61.png'
import dataSharing62 from '../../assets/images/UserManual/dataSharing62.png'
import dataSharing63 from '../../assets/images/UserManual/dataSharing63.png'
import dataSharing64 from '../../assets/images/UserManual/dataSharing64.png'


import dashboards1 from '../../assets/images/UserManual/dashboards1.png'
import dashboards2 from '../../assets/images/UserManual/dashboards2.png'
import dashboards3 from '../../assets/images/UserManual/dashboards3.png'

import eu1 from '../../assets/images/UserManual/eu1.png'
import eu2 from '../../assets/images/UserManual/eu2.png'
import eu3 from '../../assets/images/UserManual/eu3.png'
import eu4 from '../../assets/images/UserManual/eu4.png'
import eu5 from '../../assets/images/UserManual/eu5.png'
import eu6 from '../../assets/images/UserManual/eu6.png'
import eu7 from '../../assets/images/UserManual/eu7.png'
import eu8 from '../../assets/images/UserManual/eu8.png'
import eu9 from '../../assets/images/UserManual/eu9.png'
import eu10 from '../../assets/images/UserManual/eu10.png'
import eu11 from '../../assets/images/UserManual/eu11.png'




const SendMailForm = () => {
    const [recipients, setRecipients] = useState([]);
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [allUsernames, setAllUsernames] = useState([]);
    const [allRoles, setAllRoles] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [allOrgs, setAllOrgs] = useState([]);
    const [selectedOrgs, setSelectedOrgs] = useState([]);
    const [allRegs, setAllRegs] = useState([]);
    const [selectedRegs, setSelectedRegs] = useState([]);
    const navigate = useNavigate();
    const { state, user } = useContext(AuthContext);

    // Si tiene la 5 y no la 2 --> Regional coordinator
    // Si tiene la 1 y no tiene ni la 5 ni la 2 --> Regional user




    const getRequests = async () => {
        try {
            const response = await new UserService().getAllUsers();
            return response.data;
        } catch (error) {
            console.log("error listing requests", error);
            throw error;
        }
    }

    useEffect(() => {
        const fetchAllUsernames = async () => {
            try {
                const users = await getRequests();
                const usernames = users.map(usuario => usuario.userName);
                setAllUsernames(usernames);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchAllUsernames();
    }, []);

    useEffect(() => {
        const fetchAllRoles = async () => {
            const roles = await new UserService().getAllRoles();
            setAllRoles(roles.data);
        };
        fetchAllRoles();
    }, []);

    useEffect(() => {
        const fetchAllOrgs = async () => {
            const allOrgs = await new UserService().getAllOrgs();
            setAllOrgs(allOrgs.data);
        };
        fetchAllOrgs();
    }, []);

    useEffect(() => {
        const fetchAllRegs = async () => {
            try {
                const allRegionalPartners = await new AuxiliaryService('auxData/regionalpartner').getAuxiliaries();
                const regionalPartners = allRegionalPartners[0].auxtableDetailsDTOList.map(item => item.txtDescription);
                setAllRegs(regionalPartners);
            } catch (error) {
                console.error("Error al recuperar datos:", error);
            }
        };

        fetchAllRegs();
    }, []);

    const startIndex = (user.roles == "ADMIN" || user.roles == "COORDINATOR" || user.roles == "REGIONALUSER") ? 2 : 1;

    const Index = () => (
        <div>
            <h3>Index</h3>
            <ul>
                <li>
                    <a href="#introduction">1. Introduction</a>
                </li>
                {(user.roles == "ADMIN" || user.roles == "COORDINATOR" || user.roles == "REGIONALUSER") && (
                    <>
                        <li>
                            <a href="#data-collection">{startIndex}. Data Collection Module</a>
                        </li>
                        <ul>
                            <li><a href="#main-screen">{startIndex}.1. Main Screen Interface</a></li>
                        </ul>
                        {user.roles == "ADMIN" && (
                            <ul>
                                <li><a href="#tcps-subject">{startIndex}.2. TCPS Subject Matter Expert/TCPS SME</a></li>
                            </ul>
                        )}
                        {user.roles == "COORDINATOR" && (
                            <ul>
                                <li><a href="#regional-coordinator">{startIndex}.2. Regional Coordinator</a></li>
                            </ul>
                        )}
                        {user.roles == "REGIONALUSER" && (
                            <ul>
                                <li><a href="#regional-user">{startIndex}.2. Regional User</a></li>
                            </ul>
                        )}
                    </>
                )}
                <li>
                    <a href="#data-sharing">{startIndex + 1}. Data Sharing Module</a>
                    <ul><li><a href="#main-screen-data-sharing">{startIndex + 1}.1. Main Screen Interface</a></li></ul>
                    <ul><li><a href="#map-navigation">{startIndex + 1}.2. Map Navigation</a></li></ul>
                    <ul><li><a href="#widgets">{startIndex + 1}.3. Widgets</a></li></ul>
                    <ul><ul><li><a href="#show-label">{startIndex + 1}.3.1 Show Label</a></li></ul></ul>
                    <ul><ul><li><a href="#extract-data">{startIndex + 1}.3.2 Extract Data</a></li></ul></ul>
                    <ul><ul><li><a href="#draw-rectangle">{startIndex + 1}.3.3. Draw Rectangle Widget</a></li></ul></ul>
                    <ul><ul><li><a href="#share-widget">{startIndex + 1}.3.4. Share Widget</a></li></ul></ul>
                    <ul><ul><li><a href="#print-widget">{startIndex + 1}.3.5. Print Widget</a></li></ul></ul>
                    <ul><ul><li><a href="#basemap-gallery-widget">{startIndex + 1}.3.6. BaseMap Gallery Widget</a></li></ul></ul>
                    <ul><ul><li><a href="#legend-widget">{startIndex + 1}.3.7. Legend Widget</a></li></ul></ul>
                    <ul><ul><li><a href="#layer-list-widget">{startIndex + 1}.3.8. Layer List Widget</a></li></ul></ul>
                    <ul><li><a href="#toolbar">{startIndex + 1}.4. Toolbar</a></li></ul>
                    <ul><ul><li><a href="#filtering-tool">{startIndex + 1}.4.1 Filtering tool</a></li></ul></ul>
                    <ul><ul><li><a href="#info-summary-tool">{startIndex + 1}.4.2 Info Summary Tool</a></li></ul></ul>
                    <ul><ul><li><a href="#select-tool">{startIndex + 1}.4.3 Select Tool</a></li></ul></ul>
                    <ul><ul><li><a href="#draw-tool">{startIndex + 1}.4.4 Draw Tool</a></li></ul></ul>
                    <ul><ul><li><a href="#measurement-tool">{startIndex + 1}.4.5 Measurement Tool</a></li></ul></ul>
                    <ul><ul><li><a href="#print-tool">{startIndex + 1}.4.6 Print Tool</a></li></ul></ul>
                    <ul><ul><li><a href="#bookmark-tool">{startIndex + 1}.4.7 Bookmark Tool</a></li></ul></ul>
                    <ul><ul><li><a href="#add-data-tool">{startIndex + 1}.4.8 Add Data Tool</a></li></ul></ul>
                    <ul><ul><li><a href="#share-tool">{startIndex + 1}.4.9 Share Tool</a></li></ul></ul>
                    <ul><ul><li><a href="#spatial-query-tool">{startIndex + 1}.4.10 Spatial Query Tool</a></li></ul></ul>
                    <ul><ul><li><a href="#coordinate-conversion-tool">{startIndex + 1}.4.11 Coordinate Conversion Tool</a></li></ul></ul>
                    <ul><li><a href="#attribute-table">{startIndex + 1}.5. Attribute Table</a></li></ul>
                </li>
                <li>
                    <a href="#dashboards">{startIndex + 2}. Dashboards</a>
                </li>
                <li>
                    <a href="#euaquis">{startIndex + 3}. EU Acquis Module</a>
                    <ul><li><a href="#docu-search">{startIndex + 3}.1. Document Search</a></li></ul>
                    <ul><ul><li><a href="#down-search">{startIndex + 3}.1.1. Download Search</a></li></ul></ul>
                    <ul><ul><li><a href="#dynamic-search">{startIndex + 3}.1.2. Dynamic Search</a></li></ul></ul>
                    <ul><li><a href="#docu-display">{startIndex + 3}.2. Document Display</a></li></ul>
                </li>
            </ul>
        </div>
    );

    const Introduction = () => (
        <div>
            <h2 id="introduction">1. Introduction</h2>
            <p>
                The purpose of this document is to provide all necessary information on the system's functionalities to the future users of TODIS, Transport Observatory Database/Information System. This will enable TODIS users to learn how to use the system effectively and enhance their experience.
            </p>
            <p>
                Additionally, users will be equipped to troubleshoot certain problems related to system functionalities, thereby reducing support burden. TODIS also includes a help desk that provides necessary support when needed.
            </p>
            <p>
                This document is divided into two parts:
                <ol>
                    <li>Manual for Data Collection Module.</li>
                    <li>Manual for Data Sharing Module (including Data Analysis Module).</li>
                </ol>
            </p>
            <p>
                Furthermore, different user profiles have been considered, as they will fall under different categories:
                <ul>
                    <li>Regional User (RU);</li>
                    <li>Regional Coordinator (RC);</li>
                    <li>TCPS Subject Matter Expert (TCPS SME).</li>
                </ul>
            </p>
        </div>
    );

    const DataCollectionModule = () => (
        (user.roles == "ADMIN" || user.roles == "COORDINATOR" || user.roles == "REGIONALUSER") && (
            <div>
                <h2 id="data-collection">{startIndex}. Data Collection Module</h2>
                <p>
                    This section describes all functionalities of the Data Collection Module.
                </p>

                <h4 id="main-screen">{startIndex}.1. Main Screen Interface</h4>
                <p>
                    Once the user accesses the system, the following window will appear:
                </p>
                <img className={`${style.manualimage}`} src={introductionImage} alt="Main Screen Interface" />
                <p>
                    From here, users can access the system by entering their credentials. Depending on the level of authority associated with the credentials entered, they will have access to certain functionalities. A "Forgot Password?" option is available in case they do not remember their login password. Once this option is selected, the user will be redirected to the following window:
                </p>
                <img className={`${style.manualimage}`} src={forgotpassword} alt="Forgot Password Interface" />

                <p>
                    To recover a password, the user must provide an email address associated with a registered user in the system. If this is done the a temporary access token will be sent to the email, with which the user can log in, and then access the "Change password" functionality. This will be explained later.
                </p>

                <p>
                    Once they have logged in with their credentials, the following window will be displayed, which corresponds to the "TCPS/SME" user type and will be explored in more detail in the next section:
                </p>
                <img className={`${style.manualimage}`} src={introductionImage} alt="Logged with credentials" />
                <p>
                    From this point, they can easily access either of the two modules, "Data Sharing" and "Data Collection". The following sections will explain the workflow that should be followed for the proper use of the "Data Collection" module, differentiating between the various roles and the functionalities each of them can access. In addition, all users have the option to access their profile information, change their password, or log out. By selecting the drop-down menu located to the right of the user's name (top right of the screen), these options will appear.
                </p>

                <p>
                    In the first place, "My Profile", where the information of the user who is logged in is shown. Among this information, they can find the username, email address, the roles and regional partners associated, and finally the different types of permissions that the user has.
                </p>
                <img className={`${style.manualimage}`} src={userProfile} alt="User Profile" />
                <img className={`${style.manualimage}`} src={allowNoti} alt="allow notification" />
                <p>
                    The "Allow notifications by Email" button is used to control whether or not email notifications are sent when tasks change states, new tasks are assigned, or similar events occur. If this button is deactivated, email notifications will not be sent under these circumstances.
                </p>
                <p>
                    However, if the TCPS or system administrator sends an email through the system, that email will still be delivered regardless of whether email notifications are deactivated or not. This is due to the urgency associated with such emails, which takes precedence over the email notification settings of the system.
                </p>




                <p>
                    There is also the "Change password" option, from which you can provide a new password for the user. This form is validated and includes the option to confirm the password.
                </p>
                <img className={`${style.manualimage}`} src={changePassword} alt="Change password" />

                <p>
                    Finally, with the "Sign out" option, the user will be logged out and returned to the login window.
                </p>

                {user.roles == "ADMIN" ? (
                    <React.Fragment>
                        <h4 id="tcps-subject">{startIndex}.2. TCPS Subject Matter Expert/TCPS SME</h4>
                        <p>
                            Users with the "TCPS/SME" role have several functions. They are responsible for creating the "Data Collection Request", including the assignment of the "Regional Coordinator" and "Regional User" in charge of it. They also provide the final validation for the request and have the authority to ultimately accept or reject it. Additionally, they are aware of the entire workflow as they receive all notifications regarding the status of the "Data Collection Request."
                        </p>
                        <p>
                            Once logged in with the "TCPS/SME" role, the home page seen in the previous section will be displayed. From there we will have the option to access the "Data Collection" module.
                        </p>
                        <img className={`${style.manualimage}`} src={loggedTCP} alt="TCPS Loged" />

                        <p>
                            After this, the user will be redirected to the "Requests" window where two main sections can be observed.
                        </p>
                        <img className={`${style.manualimage}`} src={requestTCP} alt="Left Side - Data Collection Requests" />

                        <p>
                            On the left side all the data collection requests are displayed. These can be filtered according to the fields "Regional Partner", "Status", "Type" and "Date". It could be also sorted in ascending or descending order according to their identifier. There is also a refresh button to update the information shown. In addition, the user can access the details of each request, where they can see all the information stored on it, including the request history, which shows the workflow followed up to that moment. Finally, there is also the possibility of deleting the request, but this option will only be available if the request status is "New".
                        </p>

                        <img className={`${style.manualimage}`} src={details} alt="Details" />

                        <p>
                            On the right side of the "Request" section, there is a list of the requests that can be updated. These requests can be filtered according to the fields "Regional Partner", "Module", "EU Acquis Sector", and "Regulatory Area". The filters that are being used can be seen in the fields just below the filters themselves. In this section, there are several functionalities. The user can select one or several requests:
                        </p>
                        <ul>
                            <li>"Create Data Collection Request" (button at the bottom right)</li>
                            <li>"Create New Item to Monitor" (first button at the top right)</li>
                            <li>"Create New EU Acquis"</li>
                        </ul>
                        <p>
                            These three options will be explored in more detail below.
                        </p>
                        <p>
                            After selecting one or more existing data collections and clicking on the "Create Data Collection Request" option, a pop-up window will appear, in which a "Regional User" must be assigned to complete the request form and specify a validity date. After this, the "Create request" option can be selected, which will appear to the assigned "Regional User" to continue the process.
                        </p>
                        <img className={`${style.manualimage}`} src={createRequestPopupImage} alt="Create Request Popup" />

                        <p>
                            To create a "New Item to Monitor", click on the option "Create New Item to Monitor". Once this option has been selected, a pop-up window will appear with a form to be completed.
                        </p>
                        <img className={`${style.manualimage}`} src={newItemPopupImage} alt="New Item to Monitor Popup" />

                        <p>
                            To create a "New EU Acquis Request", click on the option "Create New EU Acquis". Once this option has been selected, a pop-up window will appear with a form to be completed.
                        </p>
                        <img className={`${style.manualimage}`} src={newEUAcquisPopupImage} alt="New EU Acquis Request Popup" />

                        <p>
                            The "Notifications" tab can be accessed from the top navigation menu. All real-time notifications will appear there, adding relevant information about the task they refer to, as well as a link to the task. The notifications can be filtered by date and sorted in ascending or descending order. This panel also has a refresh option. Clicking on a notification link will redirect the user to the corresponding task in the "Tasks" section.
                        </p>
                        <img className={`${style.manualimage}`} src={notificationsTabImage} alt="Notifications Tab" />

                        <p>
                            By selecting the "Tasks" option in the top navigation menu, the user will be redirected to a window showing all the tasks, classified according to their status ("Pending", "In progress", and "Done").
                            Furthermore, the TCPS has the "Import Data" option. If you click this button, it will give you the option to import multiple tasks in bulk that will be assigned to the users chosen by the TCPS.
                        </p>
                        <img className={`${style.manualimage}`} src={tasksWindowImage} alt="Tasks Window" />


                        <p>
                            In this pop-up, after selecting the Excel file containing all the correctly entered data, you will see three fields that need to be filled out:
                            <ul>
                                <li>Module: Choose between "TENT-T Network Performance Monitoring" or "TEN-T Projects"</li>
                                <li>Transport Mode: Select from the various types of transport modes available.</li>
                                <li>Assigned to: Choose the user to whom the tasks will be assigned.</li>
                            </ul>
                        </p>

                        <img className={`${style.manualimage}`} src={importData} alt="Import Data Window" />



                        <p>
                            The user with "TCPS/SME" authority has the last word in validating a request and therefore has the power to change the status from "In progress" to "Done". In order to finalize the process, the user will have to click on a given task and click on the "Validate Data Collection" button. It should be noted that once the user clicks on a pending task, it will automatically change from "Pending" to "In progress", and once validated, it will be marked as "Done".
                        </p>

                        <img className={`${style.manualimage}`} src={validateDataCollectionImage} alt="Validate Data Collection" />

                        <p>
                            After selecting the "Validate Data Collection" option, the window shown in the image below will appear. From here, the user will be able to review all the fields and to check their validity.
                        </p>

                        <img className={`${style.manualimage}`} src={changesRequest} alt="Verify the data" />

                        <p>
                            The "TCPS/SME" user also has the option to make changes to the request using the "Save" option. This option is available in case the user wants to correct some of the data in the form without rejecting the request. After saving the modifications, a pop-up window will appear for the user to detail these changes.
                        </p>
                        <img className={`${style.manualimage}`} src={saveChangesPopupImage} alt="Save Changes Popup" />

                        <p>
                            After reviewing the fields, the user has the option to "Reject" or "Accept" the request. If rejected, the user will be prompted to fill in a small form explaining the reason for the rejection.
                        </p>
                        <img className={`${style.manualimage}`} src={rejectRequestPopupImage} alt="Reject Request Popup" />

                        <p>
                            In both cases, after completing this process, a message will appear informing the "TCPS/SME" whether the request has been accepted or rejected correctly. Consequently, the "Regional User" responsible for filling in the "Data Collection Request" will be notified of the acceptance/rejection.
                        </p>
                    </React.Fragment>
                )
                    : null}
                {user.roles == "COORDINATOR" ? (
                    <React.Fragment>
                        <h4 id="regional-coordinator">{startIndex}.2. Regional Coordinator</h4>
                        <p>
                            In this section, the functionalities of the "Regional Coordinator" will be explained in detail.
                            After logging in with the relevant credentials, the main task of this type of user, as far as the "Data Collection" module is concerned, is to accept and perform the first validation of the data collection fulfilled by the "Regional User".
                            To do this, the user must select the "Tasks" option in the top navigation menu. After this, the user will be redirected to a window showing all the tasks, classified according to their status ("Pending", "In progress" and "Done").
                        </p>

                        <img className={`${style.manualimage}`} src={tasksWindowImageReg} alt="Tasks Window" />

                        <p>
                            As previously mentioned, the "Regional coordinator" is responsible for providing an initial validation of the data collection filled out by the "Regional user". To do this, the RC will have to click on a given task and click on the "Validate data collection" button.
                        </p>
                        <img className={`${style.manualimage}`} src={validateDataCollectionImage} alt="Validate Data Collection Form" />

                        <p>
                            As can be seen in the images above, the form to fulfill depends on whether it's for an "Item to Monitor" (first image) or for an element of the "EU Acquis" type (second image).
                        </p>
                        <img className={`${style.manualimage}`} src={itemToMonitorFormImageReg} alt="Item to Monitor Form" />
                        <img className={`${style.manualimage}`} src={euAcquisFormImageReg} alt="EU Acquis Form" />

                        <p>
                            The RC user also has the "Save" option, as well as the "TCPS/SME" user, in case they want to correct some of the data in the form but do not see the need to reject the request.
                        </p>

                        <p>
                            Once the user has checked these fields, they have the option to "Reject" as well as the option to "Accept". If the information is rejected, a pop-up window will appear in which you will have to fill in a small form explaining the reason for the rejection.
                        </p>
                        <img className={`${style.manualimage}`} src={rejectRequestPopupImageReg} alt="Reject Request Popup" />

                        <p>
                            In both cases, after finishing this process, a message will appear informing the user that it has been accepted or rejected correctly. Same as in the case of the TCPS, the "Regional User" responsible for filling in the "Data Collection Request" will be notified of the acceptance/rejection.
                        </p>
                    </React.Fragment>
                ) : null}

                {user.roles == "REGIONALUSER" ? (
                    < React.Fragment >
                        <h4 id="regional-user">{startIndex}.2. Regional User</h4>
                        <p>
                            In this section, the functionalities of the "Regional User" will be described in detail.
                            Following the workflow, once the "TCPS/SME" has created a "Data Collection Request" and has assigned it to this user, it will appear in the "Tasks" window. By accessing this window, the user will be able to see the list of all tasks. A panel with the last four notifications received will be displayed on the right. The date of the notification and the ID of the task to which it is linked will be shown. The "Notifications" section can also be accessed by clicking on the "View All" option.
                        </p>
                        <img className={`${style.manualimage}`} src={regionalCoordinatorTasksImage} alt="Regional Coordinator Tasks Window" />

                        <p>
                            Once the user starts working on the task, it will be transitioned from "Pending" to "Working on" status. After this, the next window will open, from which the fill-in form can be accessed and that way the "Data Collection Request" completed.
                        </p>
                        <p>
                            In the first instance, the following window will appear, from which the information on the type of "Data Collection Request" requested by the "TCPS/SME" can be viewed and reviewed.
                        </p>
                        <img className={`${style.manualimage}`} src={regionalCoordinatorValidateDataCollectionImage} alt="Regional User Item to Monitor Form" />

                        <p>
                            From here, by clicking on the "Start Data Collection" button, the "Regional User" can access the form that needs to be completed with the requested information. The content of the form type may vary depending on the type of "Data Collection Request" requested by the "TCPS/SME".
                        </p>
                        <img className={`${style.manualimage}`} src={regionalUserItemToMonitorFormImage} alt="Regional User Item to Monitor Form" />

                        <p>
                            In any case, the "Regional User" must fill in at least the mandatory fields correctly. The content of the form will vary depending on the type of transport in question, although the first tab of the form will always be "General", where the basic information of the request can be included, as well as personal and contact data of the responsible person.
                        </p>

                        <p>
                            A field to highlight in the form is the "Remarks" field, where the user can include comments or information of interest, which will appear in the request during the other stages of the workflow. These annotations can be added in any of the sections of the form, not only in the "General" tab.
                        </p>

                        <p>
                            A notable button is the "Import Data" button, which, when clicked, allows us to quickly and easily fill out a form by inserting an Excel file containing a single row of data.
                        </p>

                        <p>
                            Also, for the EU Acquis request a similar window will appear but with the different information to be included.
                        </p>
                        <img className={`${style.manualimage}`} src={regionalUserEUAcquisFormImage} alt="Regional User EU Acquis Form" />

                        <p>
                            This is where all needed information should be included in the forms. Certain information in the form will already be filled-in, depending on the parameters chosen by the "TCPS/SME" when creating the request. In the case of EU Acquis requests, the same information must be provided for both new requests and updates. Firstly, the value "Transposition status", which can be "Unknown", "Transposed", "Not transposed" or "Partially transposed". In addition to this, the "Tables of concordance" may be attached as an attachment and any "Remarks".
                        </p>
                        <p>
                            Let's see two examples, one in the case that the "TCPS/SME" creates a request and the "Regional User" must complete it from the beginning and the second one, regarding an already existing request that needs to be updated. In the first case, the "Regional User" will receive a task that will appear as follows:
                        </p>
                        <img className={`${style.manualimage}`} src={regionalUserUpdatedRequestFormImage} alt="Regional User updating Request Task" />

                        <p>
                            As can be seen, only the fields whose information was provided when creating the request are filled in. The other fields are empty or with an initial value, with the idea that the "Regional User" is the one in charge of filling in all these fields with the relevant information.
                        </p>

                        <p>
                            The other sections, apart from "General", will also be left in blank. These fields are not mandatory, i.e., it is not strictly necessary to complete them in order to submit the task, although any valuable information provided, may help the correct flow of information.
                        </p>

                        <p>
                            The second example concerns the completion of an existing application that needs to be updated. In this case, as can be seen in the image below, there is considerably more information already in place.
                        </p>
                        <img className={`${style.manualimage}`} src={regionalUserUpadated2RequestFromImage} alt="Regional User updating Request Task" />

                        <p>
                            All mandatory information should already be present in the request, although it may be necessary to update some of these fields, that is the task of the "Regional User" in this case. In addition, additional information may also be found in the other sections of the request, so all of them should be checked. For example, in this case, there was information in the "Infrastructure" section, which should be updated by the "Regional User" if deemed necessary.
                        </p>
                        <img className={`${style.manualimage}`} src={regionalUserInfra} alt="Regional User updating Request Task" />
                        <p>
                            At any time, changes can be saved by clicking the "Save" button, which allows finalizing the form later. The possibility of uploading a file is available, using the "Import data" option. In this case, when uploading a file, which must be less than 50MB in size, the form will be filled in automatically.
                        </p>
                        <img className={`${style.manualimage}`} src={regUserImport} alt="Regional User Importing Data" />

                        <p>
                            The "Regional User" has the option "Validate", from which they can check if the filled form has errors. Selecting this option will open a pop-up window where the errors will be mentioned if any. If not, a message will be displayed saying that no errors have been found.
                        </p>
                        <img className={`${style.manualimage}`} src={regUserValidate} alt="Regional User Valitating Data" />

                        <p>
                            Once the form has been checked for validity, the "Submit" option can be selected. If it was successfully validated, the form will be set to "Done" status. If the user wishes to discard the changes made to the form, the "Discard" option can be selected, and the task will remain in "In progress" status.
                        </p>
                        <p>
                            There could be a scenario where the information provided by the "Regional User" is rejected the TCPS or RC user. In such a case, the respective "Regional User" would receive a notification, which can be viewed from the "Notifications" section. At this point, the "Regional User" can reopen the form of the "Data Collection Request," fix the errors, and resubmit the form. In this case, a pop-up window will appear where the "Regional User" will have to add comments about the adjustments they have made.
                        </p>
                    </React.Fragment>
                ) : null
                }
            </div >
        ));

    const DataSharingModule = () => (
        <div>
            <h2 id="data-sharing">{startIndex + 1}. Data Sharing Module</h2>
            <p>
                This section describes all functionalities of the Data Sharing Module.
            </p>

            <h4 id="main-screen-data-sharing">{startIndex + 1}.1. Main Screen Interface</h4>
            <p>
                As explained in the section 2.1, once the user has logged in with its credentials, the following window will be displayed:
            </p>
            <img className={`${style.manualimage}`} src={dataSharing1} alt="Main Screen Interface" />

            <p>
                From this point, the user can access either "Data Sharing" and "Data Collection" Module.
            </p>
            <p>
                Click on "Data Sharing" to access the module.
            </p>
            <img className={`${style.manualimage}`} src={dataSharing2} />

            <h4 id="map-navigation">{startIndex + 1}.2. Map Navigation</h4>

            <p>
                To move around the map:
            </p>
            <ol>
                <li>
                    <b>Click and drag:</b> Click on the map, hold down the mouse button, and drag in any direction to move the map.
                </li>
                <li>
                    <b>Arrow keys:</b> If using a keyboard, use the arrow keys to pan the map in different directions.
                </li>
                <li>
                    <b>Double-click:</b> Double-click on the map to zoom in on that location.
                </li>
                <li>
                    <b>Scroll wheel:</b> Use the scroll wheel to zoom in and out.
                </li>
            </ol>
            <p>
                <b>Zooming In and Out:</b>
            </p>
            <ol>
                <li>
                    <b>To zoom in:</b>
                    <ol type="a">
                        <li>Double-click on the map to zoom in on the location clicked.</li>
                        <li>Click the "+" button in the bottom-right corner to zoom in incrementally.</li>
                    </ol>
                </li>
                <li>
                    <b>To zoom out:</b>
                    <ol type="a">
                        <li>Click the "-" button in the bottom-right corner to zoom out incrementally.</li>
                        <li>Scroll the mouse wheel away from you to zoom out.</li>
                    </ol>
                </li>
            </ol>
            <p>
                <b>Default Extent:</b> The "Default Extent" button (represented by a house icon) resets the map to its original view.
            </p>
            <p>
                <b>My Location:</b> The "My Location" button (represented by a small circle) centers the map on your current location based on your device's GPS or Wi-Fi positioning.
            </p>
            <p>
                The <b>Scales</b> on the bottom-right corner of the map provide a visual reference of the level of detail shown on the map,
                indicating the ratio between a distance on the map and the corresponding distance on the ground.
            </p>
            <p>
                <b>Pop-up:</b> The Pop-up allows users to access alphanumeric data associated with map features by simply clicking on them.
                This information is displayed in a pop-up window. The "Details" button expands a panel to categorize and present the same
                information in a structured format. Additionally, a "Print PDF" button enables users to download the element's data as a PDF file.
            </p>
            <p>
                Here's how you can utilize the Pop-up and Details functionality:
            </p>
            <img className={`${style.manualimage}`} src={dataSharing3} />

            <h4 id="widgets">{startIndex + 1}.3. Widgets</h4>
            <p>
                Located in the top-right corner of the map interface, it contains various buttons representing different functions and tools.
            </p>

            <img className={`${style.manualimage}`} src={dataSharing4} />

            <h5 id="show-label">{startIndex + 1}.3.1 Show Label </h5>

            <p>
                <img src={dataSharing5} /> This widget helps labeling any attribute as per the user necessity. Clicking on the widget button, a pop-up window will open:
            </p>
            <img className={`${style.manualimage}`} src={dataSharing6} />

            <p>
                After that, the module, layer, and the desired field should be selected from the drop-down menu.
            </p>
            <img className={`${style.manualimage}`} src={dataSharing7} />

            <p>
                Clicking on the “Show Labels” the map will be labeled according to the selection.
            </p>
            <img className={`${style.manualimage}`} src={dataSharing8} />
            <p>
                If no longer the labeling is needed, it could be deleted by clicking on the “Delete Labels”.
            </p>


            <h5 id="extract-data">{startIndex + 1}.3.2. Extract Data </h5>

            <p>
                <img src={dataSharing9} /> TODIS data could be extracted in different formats: ShapeFile, KMZ and GeoJSON. Clicking on the widget “Extract data”, the following pop-up widow will open:
            </p>
            <img className={`${style.manualimage}`} src={dataSharing10} />

            <p>
                Before selecting the format, the user should select a layer that wants to extract. If the layer is not selected, a red flag will appear.
            </p>
            <img className={`${style.manualimage}`} src={dataSharing11} />
            <p>
                Once the layer is selected, the user can choose from the drop-down menu the needed format and click on the “Run” button.
            </p>
            <p>
                Data will be downloaded in the required format.
            </p>
            <p>
                The button “Draw” allows direct drawing on the map by clicking on the left button of the mouse.
            </p>
            <img className={`${style.manualimage}`} src={dataSharing12} />


            <h5 id="draw-rectangle">{startIndex + 1}.3.3. Draw Rectangle Widget </h5>
            <p>
                <img src={dataSharing13} /> The Draw Rectangle widget allows users to draw rectangles on the map to define an area of interest to export as an image. To use this widget:
            </p>
            <ol type="a">
                <li>Locate the Draw Rectangle button in the top-right corner.</li>
                <li>Click on the Draw Rectangle button to activate the widget.</li>
                <li>On the map, click and drag the cursor to draw a rectangle. Release the mouse button to complete the drawing.</li>
                <img className={`${style.manualimage}`} src={dataSharing14} />
                <li>Click on the Export button to export it as an image.</li>
                <img className={`${style.manualimage}`} src={dataSharing15} />

            </ol>


            <h5 id="share-widget">{startIndex + 1}.3.4. Share Widget </h5>
            <p>
                <img src={dataSharing16} /> The Draw Rectangle widget allows users to draw rectangles on the map to define an area of interest to export as an image. To use this widget:
            </p>
            <ol type="a">
                <li>Look for the Share button in the top-right corner.</li>
                <li>Click on the Share button to open the sharing options.</li>
                <li>Select the desired sharing method, such as generating a URL or embedding the map.</li>
                <img className={`${style.manualimage}`} src={dataSharing17} />

            </ol>

            <h5 id="print-widget">{startIndex + 1}.3.5. Print Widget </h5>
            <p>
                <img src={dataSharing18} /> The Print widget allows users to create printable maps with specific layouts and configurations. To use this widget:
            </p>
            <ol type="a">
                <li>Locate the Print button in the top-right corner.</li>
                <li>Click on the Print button to open the printing options.</li>
                <li>Configure the print settings, such as paper size, orientation, and format.</li>
                <img className={`${style.manualimage}`} src={dataSharing19} />
            </ol>

            <h5 id="basemap-gallery-widget">{startIndex + 1}.3.6. BaseMap Gallery Widget</h5>
            <p>
                <img src={dataSharing20} /> The BaseMap Gallery widget offers a collection of basemaps that users can switch between for different visual representations of the underlying map. To use this widget:
            </p>
            <ol type="a">
                <li>Find the BaseMap Gallery button in the top-right corner.</li>
                <li>Click on the BaseMap Gallery button to open the basemap selection panel.</li>
                <li>Choose the desired basemap from the available options.</li>
                <li>The map display will update to reflect the selected basemap.</li>
                <img className={`${style.manualimage}`} src={dataSharing21} />
            </ol>

            <h5 id="legend-widget">{startIndex + 1}.3.7. Legend Widget</h5>
            <p>
                <img src={dataSharing22} /> The Legend widget provides a visual representation of the map's layers and their associated symbology or styles. To use this widget:
            </p>
            <ol type="a">
                <li>Locate the Legend button or icon Legend Icon in the top-right corner.</li>
                <li>Click on the Legend button to open the legend panel.</li>
                <li>Explore the legend to understand the representation of different map layers and their symbiology.</li>
                <li>The legend may include information on colors, symbols, and labels used to depict features or thematic information.</li>
                <img className={`${style.manualimage}`} src={dataSharing23} />
            </ol>


            <h5 id="layer-list-widget">{startIndex + 1}.3.8. Layer List Widget</h5>
            <p>
                <img src={dataSharing24} /> The Layer List widget allows users to view and manage the layers present in the Web GIS app. To use this widget:
            </p>
            <ol type="a">
                <li>Look for the Layer List button or icon Layer List Icon in the top-right corner.</li>
                <li>Click on the Layer List button to open the layer list panel.</li>
                <li>Review the list of layers and their properties.</li>
                <li>Enable or disable layers or adjust their visibility settings as required.</li>
                <img className={`${style.manualimage}`} src={dataSharing25} />
            </ol>



            <h5 id="toolbar">{startIndex + 1}.4. Toolbar</h5>
            <p>
                Located in the left of the map interface, it contains various buttons representing different functions and tools.
            </p>
            <img className={`${style.manualimage}`} src={dataSharing26} />


            <h5 id="filtering-tool">{startIndex + 1}.4.1 Filtering tool</h5>

            <p>
                <img src={dataSharing27} />The Filtering tool allows users to filter the displayed data based on specific criteria. To use this tool, follow these steps:
            </p>

            <ol>
                <li>Locate the Filtering tool in the toolbar or sidebar.</li>
                <li>Click on the Filtering tool to activate it.</li>
                <li>The Filtering panel will appear, showing the available filter categories.</li>
            </ol>

            <u>Filter Categories</u>

            <p>
                The Filtering tool provides several categories for filtering the data. These categories may include:
            </p>

            <ul>
                <li>Module: Options include TEN-T Network, TEN-T Projects, and Thematic Maps.</li>
                <li>Regional Partner: Options include Albania, Bosnia Herzegovina, Kosovo, Montenegro, North Macedonia, and Serbia.</li>
                <li>TEN-T Category: Options include Core, Comprehensive and Core Corridor.</li>
                <li>Transport Mode: Options include Roads, Railways, Inland Waterways, Airports, Seaports, and Inland Waterway Ports.</li>
            </ul>

            <u>Additional Categories</u>
            <p>
                Depending on the selected options, additional filter categories may appear, such as:
            </p>

            <ul>
                <li>Roads:
                    <ul>
                        <li>Category</li>
                        <li>Pavement Condition</li>
                        <li>Year</li>
                    </ul>
                </li>
                <li>Railways:
                    <ul>
                        <li>Traction</li>
                        <li>Infrastructure Condition</li>
                        <li>Year</li>
                    </ul>
                </li>
                <li>TEN-T projects:
                    <ul>
                        <li>Project Status</li>
                        <li>Project Type</li>
                        <li>Year</li>
                    </ul>
                </li>
            </ul>
            <img className={`${style.manualimage}`} src={dataSharing28} />

            <p>
                Choosing the option for the Thematic maps, the Regional Partner shell also select the RP, TEN-T Category as well as the sector, which will be only Roads or Railways.
            </p>

            <li>Choosing Roads, different maps will be available:
                <ul>
                    <li>TEN-T Network by Category</li>
                    <li>TEN-T Network by Status</li>
                    <li>TEN-T Network by Infrastructure Profile</li>
                    <li>TEN-T Network by Pavement Condition</li>
                    <li>Network by Compliance with TEN-T Standards</li>
                    <li>Projects by Status</li>
                </ul>
            </li>
            <img className={`${style.manualimage}`} src={dataSharing29} />

            <li>On the other hand, choosing Railways, the following maps will be available:
                <ul>
                    <li>TEN-T Network by Category</li>
                    <li>TEN-T Network by Status</li>
                    <li>TEN-T Network by Traction</li>
                    <li>TEN-T Network by Axle Load</li>
                    <li>ERTMS Deployment</li>
                    <li>Train length</li>
                    <li>Infrastructure conditions</li>
                    <li>Projects by Status</li>
                </ul>
            </li>
            <img className={`${style.manualimage}`} src={dataSharing30} />

            <p>
                <u>Accessing Key Performance Indicators (KPIs)</u>
            </p>
            <p>
                Once an option is selected for Transport Mode, users can access its Key Performance Indicators (KPIs). These KPIs provide specific metrics and information related to the chosen transport mode.
            </p>

            <img className={`${style.manualimage}`} src={dataSharing31} />

            <p>
                <u>Charts (Roads and Railways only)</u>
            </p>

            <p>
                When the options Roads and Railways are selected under Transport Mode, users can access additional charts for further analysis and visualization.
            </p>

            <p>
                It can be downloaded with this button: <img src={dataSharing32} />
            </p>

            <img className={`${style.manualimage}`} src={dataSharing33} />

            <h5 id="info-summary-tool">{startIndex + 1}.4.2 Info Summary Tool</h5>

            <p>
                <img src={dataSharing34} /> The Info Summary tool provides a summary of information about selected features or data on the map. To use this tool:
            </p>

            <ol type="a">
                <li>Locate the Info Summary option in the left sidebar.</li>
                <li>Click on the Info Summary option to activate the tool.</li>
                <li>Click on a category to view relevant information summarized.</li>
                <img className={`${style.manualimage}`} src={dataSharing35} />
            </ol>

            <h5 id="select-tool">{startIndex + 1}.4.3 Select Tool</h5>

            <p>
                <img src={dataSharing36} /> The Select tool allows users to select specific features or data on the map for further analysis or display. To use this tool:
            </p>
            <ol type="a">
                <li>Locate the Select option in the left sidebar.</li>
                <li>Click on the Select option to activate the tool.</li>
                <li>Click on individual features or draw a selection area on the map to select the desired data.</li>
                <li>The selected data will be highlighted and displayed in the left panel.</li>
            </ol>

            <img className={`${style.manualimage}`} src={dataSharing37} />

            <img className={`${style.manualimage}`} src={dataSharing38} />

            <p>
                The Select tool also offers a convenient button that allows users to control the selectability of different layers on the map. This feature simplifies the selection process by allowing users to customize which layers can be selected and which ones cannot. The button provides three specific options:
            </p>

            <img className={`${style.manualimage}`} src={dataSharing39} />

            <ol>
                <li>
                    <strong>Make all layers selectable:</strong> This option enables the selectability of all layers in the map. Users can freely choose features from any visible layer using the Select tool.
                </li>
                <li>
                    <strong>Make all layers unselectable:</strong> By selecting this option, the selectability of all layers is turned off. No features from any layer can be selected until the selectability is re-enabled.
                </li>
                <li>
                    <strong>Toggle selectability for all layers:</strong> This option functions as a toggle switch. If some layers are currently selectable while others are not, clicking this button will switch the selectability status for all layers. Layers that were selectable will become unselectable, and vice versa.
                </li>
            </ol>

            <p>
                Once the desired elements are selected, additional options can be accessed by clicking on the three horizontal dots menu associated with the selection. The available options include:
            </p>

            <img className={`${style.manualimage}`} src={dataSharing40} />
            <p></p>
            <img className={`${style.manualimage}`} src={dataSharing41} />

            <ol>
                <li>
                    <strong>Zoom to:</strong> Allows you to zoom in on the selected features, providing a closer view for detailed analysis.
                </li>
                <li>
                    <strong>Pan to:</strong> Adjusts the map view to focus on the selected features, ensuring they are visible within the current map extent.
                </li>
                <li>
                    <strong>Export to CSV file:</strong> Enables exporting the selected data to a Comma-Separated Values (CSV) file format for use in other applications or data manipulation.
                </li>
                <li>
                    <strong>Export to feature collection:</strong> Exports the selected features to a feature collection file format, which can be easily shared with others or integrated into various GIS platforms.
                </li>
                <li>
                    <strong>Export to GeoJSON:</strong> Allows exporting the selected data to the GeoJSON file format, a widely used format for geographic data interchange.
                </li>
                <li>
                    <strong>Statistics:</strong> Provides statistical information or summary data for the selected features, giving valuable insights into the dataset.
                </li>
                <li>
                    <strong>Create layer:</strong> Creates a new layer using the selected features, allowing for customized styling and further analysis.
                </li>
                <li>
                    <strong>Save to My Content:</strong> Saves the selected features to your personal content or workspace for future reference.
                </li>
                <li>
                    <strong>View in attribute table:</strong> Opens the attribute table to display detailed information about the selected features.
                </li>
                <li>
                    <strong>Clear selection:</strong> Removes the current selection, allowing you to start a new selection process or clear the current selection for a clean slate.
                </li>
            </ol>

            <h5 id="draw-tool">{startIndex + 1}.4.4 Draw Tool</h5>

            <p>
                <img src={dataSharing42} /> The Draw tool within the map viewer provides users with the capability to create and annotate shapes or markers directly on the map for various annotation and analysis purposes. This versatile tool allows users to visually represent information, make annotations, perform measurements, and conduct analyses by drawing on the map. Here is a step-by-step guide on how to use the Draw tool:
            </p>

            <ol>
                <li>Locate the Draw option in the left sidebar or toolbar of the map viewer.</li>
                <li>Click on the Draw option to activate the tool, indicating that you are ready to start drawing on the map.</li>
            </ol>
            <img className={`${style.manualimage}`} src={dataSharing43} />

            <p>Once the Draw tool is activated, you can choose from different draw modes, each tailored to specific shape or marker types:</p>

            <ul>
                <li>
                    <strong>Point:</strong> Allows you to place single points on the map.
                </li>
                <li>
                    <strong>Line:</strong> Enables you to draw straight lines on the map.
                </li>
                <li>
                    <strong>Polyline:</strong> Allows you to draw connected straight or curved lines with multiple vertices.
                </li>
                <li>
                    <strong>Free Hand Polyline:</strong> Allows you to draw freehand lines with multiple vertices.
                </li>
                <li>
                    <strong>Arrow:</strong> Allows you to draw arrows on the map with adjustable direction and size.
                </li>
                <li>
                    <strong>Triangle:</strong> Enables you to draw triangles on the map.
                </li>
                <li>
                    <strong>Extend:</strong> Allows you to extend a line segment by drawing a continuation from its endpoint.
                </li>
                <li>
                    <strong>Circle:</strong> Enables you to draw circles on the map with adjustable radius.
                </li>
                <li>
                    <strong>Ellipse:</strong> Allows you to draw ellipses on the map with adjustable dimensions.
                </li>
                <li>
                    <strong>Polygon:</strong> Enables you to draw closed polygons on the map with adjustable vertices.
                </li>
                <li>
                    <strong>Free Hand Polygon:</strong> Allows you to draw freehand closed polygons with adjustable vertices.
                </li>
                <li>
                    <strong>Text:</strong> Enables you to add text labels to specific locations on the map.
                </li>
            </ul>

            <p>
                Apart from the draw modes, the Draw tool also offers various parameters that can be adjusted to customize the appearance and behaviour of the drawn shapes or markers:
            </p>

            <ul>
                <li>
                    <strong>Colour:</strong> Allows you to choose the fill colour for the drawn shapes or markers.
                </li>
                <li>
                    <strong>Transparency:</strong> Adjusts the opacity level of the drawn shapes or markers.
                </li>
                <li>
                    <strong>Outline Colour:</strong> Allows you to set the colour of the outline of the shapes or markers.
                </li>
                <li>
                    <strong>Outline Width:</strong> Adjusts the thickness of the outline of the shapes or markers.
                </li>
                <li>
                    <strong>Show Area Measurement:</strong> Option to display the area measurement of drawn polygons or circles.
                </li>
                <li>
                    <strong>Show Perimeter Measurement:</strong> Option to display the perimeter measurement of drawn polygons or circles.
                </li>
            </ul>

            <p>
                By utilizing the Draw tool's various draw modes and parameters, users can visually represent information on the map, perform measurements of areas and perimeters, create annotations, and conduct analyses, enhancing the overall analysis capabilities within the map viewer. The drawn shapes or markers can serve as valuable visual aids for communication, documentation, and decision-making processes.
            </p>

            <h5 id="measurement-tool">{startIndex + 1}.4.5 Measurement Tool</h5>

            <p>
                <img src={dataSharing44} /> The Measurement tool allows users to measure distances, areas, and location. To use this tool:
            </p>

            <ol type='a'>
                <li>
                    Locate the Measurement option in the left sidebar.
                </li>
                <li>
                    Click on the Measurement option to activate the tool.
                </li>
                <li>
                    Select the desired measurement type, such as distance, area, or location.
                </li>
                <li>
                    Choose the output units.
                </li>
            </ol>

            <img className={`${style.manualimage}`} src={dataSharing45} />

            <h5 id="print-tool">{startIndex + 1}.4.6 Print Tool</h5>

            <p>
                <img src={dataSharing46} /> The Print tool enables users to create printable maps with specific layouts and configurations. To use this tool:
            </p>

            <ol type='a'>
                <li>
                    Locate the Print option in the left sidebar.
                </li>
                <li>
                    Click on the Print option to open the printing options.
                </li>
                <li>
                    Configure the print settings, such as paper size and orientation.
                </li>
                <li>
                    Select the output format and click on “Print”.
                </li>
            </ol>
            <img className={`${style.manualimage}`} src={dataSharing47} />

            <h5 id="bookmark-tool">{startIndex + 1}.4.7 Bookmark Tool</h5>

            <p>
                <img src={dataSharing48} /> The Bookmark tool allows users to save and quickly navigate to specific map views or locations. To use this tool:
            </p>

            <ol type='a'>
                <li>
                    Locate the Bookmark option in the left sidebar.
                </li>
                <li>
                    Click on the Bookmark option to open the bookmark panel.
                </li>
                <li>
                    Create new bookmarks by specifying a name and saving the current map view.
                </li>
                <li>
                    Click on a saved bookmark to navigate to the corresponding map view.
                </li>
            </ol>

            <img className={`${style.manualimage}`} src={dataSharing49} />

            <h5 id="add-data-tool">{startIndex + 1}.4.8 Add Data Tool</h5>

            <p>
                <img src={dataSharing50} /> The Add Data tool enables users to add additional data layers or sources to the map. To use this tool:
            </p>

            <ol type='a'>
                <li>
                    Locate the Add Data option in the left sidebar.
                </li>
                <li>
                    Click on the Add Data option to open the data selection panel.
                </li>
                <li>
                    Choose the desired data source or file type to add to the map.
                </li>
            </ol>
            <img className={`${style.manualimage}`} src={dataSharing51} />

            <h5 id="share-tool">{startIndex + 1}.4.9 Share Tool</h5>

            <p>
                <img src={dataSharing52} /> The Share tool allows users to share the current map view or a specific configuration with others. To use this tool:
            </p>

            <ol type='a'>
                <li>
                    Locate the Share option in the left sidebar.
                </li>
                <li>
                    Click on the Share option to open the sharing options.
                </li>
                <li>
                    Select the desired sharing method, such as generating a URL or embedding the map.
                </li>
            </ol>

            <img className={`${style.manualimage}`} src={dataSharing53} />

            <h5 id="spatial-query-tool">{startIndex + 1}.4.10 Spatial Query Tool</h5>

            <p>
                <img src={dataSharing54} /> The Spatial Query tool within the map viewer empowers users to conduct spatial analysis and retrieve features based on their spatial relationships. This tool is a valuable asset for exploring the geographic relationships between different layers and gaining insights into spatial patterns. Let's delve into a comprehensive step-by-step guide on how to use the Spatial Query tool:
            </p>

            <ol type='a'>
                <li>
                    Locate the Spatial Query option in the left sidebar or toolbar of the map viewer.
                </li>
                <li>
                    Click on the Spatial Query option to activate the tool, which will bring up a panel with two main sections: "Task" and "Results."
                </li>
                <p>From the "Task" section, follow these steps to perform a spatial query:</p>
                <li>
                    Choose the target layer on which you wish to execute the spatial query. This is the layer from which you want to retrieve features based on their spatial relationships with other features.
                </li>
                <img className={`${style.manualimage}`} src={dataSharing55} />

                <li>Once you have selected the target layer, you will be prompted to define spatial filters or query parameters. These filters determine the spatial relationship criteria for retrieving features. Here are the available options:</li>
                <img className={`${style.manualimage}`} src={dataSharing56} />


                <li>"Only return features within the current map extent": This option retrieves features that fall within the current visible extent of the map. It helps narrow down the query to features visible on the screen.</li>
                <li>"Only return features that intersect with the shape drawn on the map": This option enables you to draw a shape directly on the map and then retrieve features from the target layer that intersect with that drawn shape. You can also apply a search distance to expand or shrink the drawn shape for the query.</li>
                <li>"Only return features that have a spatial relationship with features in another layer": This powerful option allows you to establish spatial relationships between the target layer and features in another selected layer. Spatial relationships include "Intersect," "Contain," "Cross," "Envelope Intersect," "Index Intersect," "Overlap," "Touch," and "Within."</li>
                <li>"Only return features within the full extent of the map": This option retrieves all features from the target layer that are present within the entire extent of the map, regardless of their visibility on the screen.</li>
                <li>From the "Results" section, you can access and review all the spatial queries you have previously executed. This feature allows you to refer back to the results of your spatial analyses and keep track of the queries you've conducted.</li>
                <img className={`${style.manualimage}`} src={dataSharing57} />

            </ol>

            <h5 id="coordinate-conversion-tool">{startIndex + 1}.4.11 Coordinate Conversion Tool</h5>

            <p>
                <img src={dataSharing58} /> The Coordinate Conversion tool allows users to convert coordinates between different coordinate systems or formats. To use this tool:
            </p>

            <ol type="a">
                <li>Locate the Coordinate Conversion option in the left sidebar.</li>
                <li>Click on the Coordinate Conversion option to open the conversion panel.</li>
                <li>Select the desired output coordinate system format.</li>
                <li>Enter the coordinates in the source coordinate manually, or by using the “add point” button.</li>
                <li>The selected outputs will be updated.</li>
            </ol>

            <img className={`${style.manualimage}`} src={dataSharing59} />

            <h5 id="attribute-table">{startIndex + 1}.5. Attribute Table</h5>

            <p>
                The Attribute Table is a powerful tool in the Web GIS app that displays the attributes or properties of the features within the visible extent of the map. It provides a tabular view of the data and allows for various actions, such as filtering, querying, exporting, selecting, zooming, and refreshing. Here's how you can utilize the Attribute Table within the visible extent:
            </p>

            <ol type="a">
                <li>
                    <strong>Accessing the Attribute Table:</strong>
                    <ul>
                        <li>Click on the Attribute Table option to open the table view.</li>
                    </ul>
                    <img className={`${style.manualimage}`} src={dataSharing60} />

                </li>
                <li>
                    <strong>Table View:</strong>
                    <ul>
                        <li>
                            The Attribute Table will display the attributes of the features within the visible extent of the map in a tabular format.
                        </li>
                        <li>
                            Initially, all the available tables in the project may be displayed. The user will need to search for the desired table within the list placed in the right top corner.
                        </li>
                        <img className={`${style.manualimage}`} src={dataSharing61} />

                    </ul>
                </li>
                <li>
                    <strong>Filter:</strong>
                    <ul>
                        <li>
                            Utilize the Filter functionality to perform more advanced searches or analysis.
                        </li>
                        <li>
                            Locate the Filter option or button within the Attribute Table interface.
                        </li>
                        <img className={`${style.manualimage}`} src={dataSharing62} />

                        <li>
                            Define the query parameters, such as attribute values, operators, and logical conditions.
                        </li>
                        <img className={`${style.manualimage}`} src={dataSharing63} />

                        <li>
                            Execute the query to retrieve the matching records within the visible extent.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Export to CSV:</strong>
                    <ul>
                        <li>
                            Exporting the Attribute Table to a CSV (Comma-Separated Values) file allows you to work with the data in other software.
                        </li>
                        <li>
                            Click on the export option and choose the CSV format.
                        </li>
                        <img className={`${style.manualimage}`} src={dataSharing64} />

                        <li>
                            Save the exported CSV file to your desired location.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Selecting Elements:</strong>
                    <ul>
                        <li>
                            The Attribute Table enables you to select specific features or rows for further analysis or visualization.
                        </li>
                        <li>
                            Click on a row in the Attribute Table to select the corresponding feature on the map within the visible extent.
                        </li>
                        <li>
                            Multiple selection may be possible by holding down the Ctrl or Shift key while clicking on rows.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Clearing Selection:</strong>
                    <ul>
                        <li>
                            Clearing the selection removes the highlighted or selected features from the map within the visible extent.
                        </li>
                        <li>
                            Locate the clear selection option or button within the Attribute Table interface.
                        </li>
                        <li>
                            Click on the clear selection option to remove the selection.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Zoom To:</strong>
                    <ul>
                        <li>
                            The Zoom To functionality allows you to focus the map view on the selected feature or features within the visible extent.
                        </li>
                        <li>
                            Look for the zoom to option or button within the Attribute Table interface.
                        </li>
                        <li>
                            Click on the zoom to option to automatically adjust the map extent to the selected feature(s) within the visible extent.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Refresh:</strong>
                    <ul>
                        <li>
                            The Refresh option updates the Attribute Table with the latest data within the visible extent if changes have occurred.
                        </li>
                        <li>
                            Locate the refresh option or button within the Attribute Table interface.
                        </li>
                        <li>
                            Click on the refresh option to update the table with any new or modified data within the visible extent.
                        </li>
                    </ul>
                </li>
            </ol>

        </div >
    );

    const DashboardsModule = () => (
        <div>
            <h2 id="dashboards">{startIndex + 2}. Dashboards</h2>
            <p>
                TODIS app include dashboards that provide a visual summary of data and key metrics. Dashboards allow users to monitor real-time information and gain insights briefly. To access the dashboards, look for the Dashboards tab on the top side.
            </p>

            <img className={`${style.manualimage}`} src={dashboards1} />
            <p>
                The TODIS application provides a wide variety of dashboards, which may include charts, graphs, maps, and other visual elements.
            </p>
            <img className={`${style.manualimage}`} src={dashboards2} />

            <p>
                Interact with the dashboard components in the left side to view detailed information or drill down into specific data points. Customize the dashboards based on your preferences, such as selecting specific data sources or adjusting the time range for data visualization.
            </p>
            <img className={`${style.manualimage}`} src={dashboards3} />
        </div>
    );

    const EuacquisModule = () => (
        <div>

            <h2 id="euaquis">{startIndex + 3}. EU Acquis Module</h2>

            <p>
                The EU ACQUIS module provides access to legal documentation, including Directives, Decisions, and Regulations concerning different types of transport. This module allows users to customize their search by applying filters to find the desired document. Additionally, next to each document, there are two buttons: one for downloading the document and another for visualizing its status on the map. Here's how you can utilize the EU Acquis module:
            </p>

            <p>
                To access the EU Acquis, look for it on the top side tab.
            </p>
            <img className={`${style.manualimage}`} src={eu1} />

            <h4 id="docu-search">{startIndex + 3}.1. Document Search</h4>

            <p>
                Within the EU AQUIS module, you can customize your search for legal documentation.
            </p>
            <p>
                Apply filters to narrow down the search results. Here is a list of the available filters:
            </p>
            <img className={`${style.manualimage}`} src={eu2} />

            <ol>
                <li>
                    <strong>Regional Partner:</strong>
                    <ul>
                        <li>Albania</li>
                        <li>Bosnia and Herzegovina</li>
                        <li>Kosovo</li>
                        <li>Montenegro</li>
                        <li>North Macedonia</li>
                        <li>Serbia</li>
                    </ul>
                    <p>Use this option to select the specific regional partner whose legal documents you want to explore.</p>
                </li>
                <li>
                    <strong>Sector:</strong>
                    <ul>
                        <li>Public Procurement</li>
                        <li>Rail Transport Rules</li>
                        <li>Road Transport Rules</li>
                        <li>Maritime Transport Rules</li>
                        <li>Waterway Transport Rules</li>
                        <li>Environment Rules</li>
                        <li>Transport Infrastructure</li>
                    </ul>
                    <p>Select the sector relevant to your legal document search. This will help narrow down the results to the specific area of interest.</p>
                </li>
                <li>
                    <strong>Reg. Area:</strong>
                    <ul>
                        <li>(Categories vary based on the selected sector)</li>
                    </ul>
                    <p>This option provides further categorization based on the sector chosen. Choose a specific category to refine your search even more.</p>
                </li>
                <li>
                    <strong>Type of Act:</strong>
                    <ul>
                        <li>Directives</li>
                        <li>Regulations</li>
                        <li>Decisions</li>
                    </ul>
                    <p>Specify the type of legal act you are looking for. You can select one or more types according to your needs.</p>
                </li>
                <li>
                    <strong>Action Plans:</strong>
                    <ul>
                        <li>No</li>
                        <li>Rail Action Plan</li>
                        <li>Road Action Plan</li>
                        <li>Road Safety Action Plan</li>
                        <li>Waterborne and Multimodality Action Plan</li>
                        <li>Transport of Dangerous Goods Guidelines</li>
                        <li>Social Acquis Action Plan</li>
                    </ul>
                    <p>Use this option to filter documents related to specific action plans or guidelines.</p>
                </li>
                <li>
                    <strong>Status:</strong>
                    <ul>
                        <li>Partially Transposed</li>
                        <li>Not Transposed</li>
                        <li>Transposed</li>
                        <li>Unknown</li>
                    </ul>
                    <p>Select the status of the legal document's transposition to narrow down your search results.</p>
                </li>
                <li>
                    <strong>Celex Number:</strong>
                    <p>If you have a specific Celex number, enter it here to find the exact legal document.</p>
                </li>
                <li>
                    <strong>Years:</strong>
                    <p>Enter the specific years or a range of years to filter documents within your desired timeframe.</p>
                </li>
            </ol>

            <h4 id="down-search">{startIndex + 3}.1.1. Download Search</h4>

            <p>
                Once you have completed your search, you have the option to download the search results in Excel format for further analysis.
            </p>

            <img className={`${style.manualimage}`} src={eu3} />

            <p>The downloaded Excel file will contain the following information:</p>
            <ol>
                <li><strong>Sector:</strong> The specific sector related to the legal document.</li>
                <li><strong>Regulatory Area:</strong> Further categorization based on the selected sector.</li>
                <li><strong>Type of Act:</strong> The type of legal act, such as directives, regulations, or decisions.</li>
                <li><strong>Celex Number:</strong> The unique reference number of the legal document.</li>
                <li><strong>Legal Act:</strong> The title or description of the legal document.</li>
                <li><strong>Regional Partner:</strong> The regional partner associated with the legal document.</li>
                <li><strong>Transposition Status:</strong> The current status of transposition for the legal document.</li>
                <li><strong>Remark:</strong> Any additional remarks or notes related to the legal document.</li>
                <li><strong>Table of Concordance:</strong> Information regarding concordance tables, if applicable.</li>
            </ol>
            <img className={`${style.manualimage}`} src={eu4} />

            <h4 id="dynamic-search">{startIndex + 3}.1.2. Dynamic Charts</h4>

            <p>
                The EU acquis also offers a powerful feature that allows you to gain insights from the search results through dynamic charts. Here's how you can access and utilize the dynamic charts:
            </p>

            <ol>
                <li>Look for the "Charts" button located on the right-hand side of the search results page.</li>
                <img className={`${style.manualimage}`} src={eu5} />
                <li>Click on the "Charts" button to access the dynamic charting feature.</li>
                <li>
                    The dynamic charts provide valuable information about the transposition status of the legal documents. They offer insights on the transposition status for each regional partner separately and in combination.
                </li>
                <li>
                    Hover your cursor over different elements of the chart to get more detailed information about the transposition status of the legal documents.
                </li>
                <img className={`${style.manualimage}`} src={eu6} />
                <p>
                    You can download the dynamic chart by clicking the <img src={eu7} /> button, which allows you to save the chart as an image.
                </p>
            </ol>

            <h4 id="docu-display">{startIndex + 3}.2. Document Display</h4>

            <p>
                Once you find the desired document, it will be displayed on the screen.
            </p>

            <p>
                The document may contain important information and legal provisions related to the selected transport network.
            </p>

            <img className={`${style.manualimage}`} src={eu8} />

            <p><strong>Downloading Documents: </strong> <img src={eu9} /></p>
            <ol>
                <li>Locate the download button next to the document display.</li>
                <li>Click on the download button to initiate the download process.</li>
                <li>Save the document to your preferred location on your device.</li>
            </ol>

            <p><strong>Visualizing Document Status: </strong> <img src={eu10} /></p>

            <ol>
                <li>The EU AQUIS module provides the ability to visualize the status of a document on the map.</li>
                <li>Next to each document, there is a specific button for visualizing the document's status.</li>
                <li>Click on the status button to view the location or extent of the document's applicability on the map.</li>
            </ol>

            <img className={`${style.manualimage}`} src={eu11} />
        </div>
    );

    return (

        <Container fluid className="todis-form-wrapper p-4">
            <Row>
                <Col md={2} style={{ position: 'sticky', top: 0, height: 'calc(100vh - 100px)', overflowY: 'auto' }}>
                    <Index />
                </Col>
                <Col md={10}>
                    <Introduction />
                    <DataCollectionModule />
                    <DataSharingModule />
                    <DashboardsModule />
                    <EuacquisModule />
                </Col>
            </Row>
        </Container>
    );

};

export default SendMailForm;